import * as React from "react";
import { SVGProps } from "react";


const AnprLogo = (props: SVGProps<SVGSVGElement>) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            id="Layer_1"
            x="0"
            y="0"
            version="1.1"
            viewBox="0 0 2133.8 373.3"
            width={220}
            height={52}
            {...props}
        >
          <g fill="#FFF">
            <path d="M471.8 230.4h-47.3l-7.6 22.4h-32.3l45.8-126.6h35.7l45.8 126.6h-32.6zm-7.9-23.9-15.7-46.4-15.5 46.4zM650.8 252.7H620l-51.6-78.1v78.1h-30.8V126.1h30.8l51.6 78.5v-78.5h30.8zM776.2 187c-3.4 6.1-8.5 11-15.5 14.7s-15.6 5.6-26 5.6h-19.1v45.5h-30.8V126.1h50c10.1 0 18.6 1.7 25.6 5.2s12.2 8.3 15.7 14.4 5.2 13.2 5.2 21.1c-.1 7.4-1.8 14.1-5.1 20.2m-30.7-8.4c2.9-2.8 4.3-6.7 4.3-11.7 0-5.1-1.4-9-4.3-11.7-2.9-2.8-7.3-4.1-13.2-4.1h-16.8v31.7h16.8c5.9-.1 10.3-1.4 13.2-4.2M873.4 252.7 847 204.9h-7.4v47.8h-30.8V126.1h51.8c10 0 18.5 1.7 25.5 5.2s12.3 8.3 15.8 14.3c3.5 6.1 5.2 12.8 5.2 20.3 0 8.4-2.4 15.9-7.1 22.5q-7.2 9.9-21 14.1l29.2 50.1h-34.8zm-33.8-69.6h19.1c5.7 0 9.9-1.4 12.7-4.1q4.2-4.2 4.2-11.7 0-7.2-4.2-11.4c-2.8-2.8-7.1-4.1-12.7-4.1h-19.1z"></path>
          </g>
          <g fill="#FFF">
            <path d="M1077.4 224.8h-54.8l-10.1 28h-17.3l45.5-125h18.9l45.3 125h-17.3zm-4.7-13.4-22.7-63.5-22.7 63.5zM1152.3 127v79.6c0 11.2 2.7 19.5 8.2 24.9q8.25 8.1 22.8 8.1c9.6 0 17.2-2.7 22.6-8.1 5.5-5.4 8.2-13.7 8.2-24.9V127h16.4v79.4q0 15.75-6.3 26.4c-4.2 7.2-9.9 12.5-17 16-7.2 3.5-15.2 5.2-24.1 5.2s-16.9-1.7-24.1-5.2-12.8-8.8-17-16c-4.1-7.2-6.2-16-6.2-26.4V127zM1344.3 134.7q15 7.65 23.1 21.9c5.3 9.5 8 20.7 8 33.6s-2.7 24-8 33.5c-5.4 9.4-13 16.7-23.1 21.6-10 5-21.9 7.5-35.6 7.5h-39.1V127h39.1c13.7 0 25.6 2.6 35.6 7.7m1.5 91.6c8.5-8.6 12.8-20.7 12.8-36.2q0-23.4-12.9-36.6c-8.6-8.8-21-13.2-37.1-13.2h-22.7v98.9h22.7q24.45 0 37.2-12.9M1425 127v125.7h-16.4V127zM1480.9 140.3v42h45.8v13.5h-45.8v43.3h51.2v13.5h-67.6V126.8h67.6v13.5zM1667.5 252.7H1651l-66-100.1v100.1h-16.4V126.8h16.4l66 99.9v-99.9h16.4v125.9zM1709.1 156.7c5.5-9.8 13.1-17.5 22.6-23 9.6-5.5 20.2-8.3 31.8-8.3 13.7 0 25.7 3.3 35.9 9.9s17.7 16 22.4 28.1h-19.7c-3.5-7.6-8.5-13.4-15.1-17.5s-14.4-6.1-23.5-6.1c-8.8 0-16.7 2-23.6 6.1-7 4.1-12.4 9.9-16.4 17.4q-6 11.25-6 26.4c0 10 2 18.7 6 26.2s9.4 13.3 16.4 17.4 14.9 6.1 23.6 6.1c9.1 0 17-2 23.5-6 6.6-4 11.6-9.8 15.1-17.4h19.7c-4.7 12-12.1 21.3-22.4 27.9-10.2 6.6-22.2 9.8-35.9 9.8-11.7 0-22.3-2.7-31.8-8.2-9.6-5.5-17.1-13.1-22.6-22.8s-8.3-20.7-8.3-33c0-12.2 2.8-23.2 8.3-33M1874.2 140.3v42h45.8v13.5h-45.8v43.3h51.2v13.5h-67.6V126.8h67.6v13.5zM1979.4 249.6c-6.6-2.9-11.7-7-15.4-12.3-3.7-5.2-5.7-11.3-5.8-18.1h17.5c.6 5.9 3 10.9 7.3 14.9s10.5 6 18.7 6c7.8 0 14-2 18.5-5.9s6.8-8.9 6.8-15.1c0-4.8-1.3-8.7-4-11.7-2.6-3-6-5.3-9.9-6.9-4-1.6-9.3-3.2-16.1-5.1-8.3-2.2-14.9-4.3-19.9-6.5s-9.3-5.6-12.8-10.2-5.3-10.9-5.3-18.7c0-6.9 1.7-12.9 5.2-18.2q5.25-7.95 14.7-12.3c6.3-2.9 13.6-4.3 21.7-4.3 11.8 0 21.4 2.9 29 8.8 7.5 5.9 11.8 13.7 12.7 23.5h-18c-.6-4.8-3.1-9-7.6-12.7s-10.3-5.5-17.7-5.5c-6.9 0-12.4 1.8-16.8 5.3-4.3 3.5-6.5 8.5-6.5 14.9 0 4.6 1.3 8.3 3.9 11.2q3.9 4.35 9.6 6.6c3.8 1.5 9.1 3.2 16 5.1 8.3 2.3 15 4.5 20 6.8 5.1 2.2 9.4 5.7 13 10.3q5.4 6.9 5.4 18.9c0 6.1-1.6 11.9-4.9 17.3-3.2 5.4-8.1 9.8-14.4 13.2q-9.6 5.1-22.5 5.1c-8.4 0-15.8-1.5-22.4-4.4"></path>
          </g>
          <path
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M138 73.9h129.8c26.3 0 47.8 21.5 47.8 47.8v129.8c0 26.3-21.5 47.8-47.8 47.8H138c-26.3 0-47.8-21.5-47.8-47.8V121.7c0-26.3 21.5-47.8 47.8-47.8z"
          ></path>
          <path
              fill="#fff"
              d="m261.9 159-90.5-52.2c-12.4-7.2-28 1.8-28 16.1v104.5c0 14.4 15.5 23.3 28 16.1l90.5-52.2c12.5-7.2 12.5-25.1 0-32.3"
              opacity="0.8"
          ></path>
          <radialGradient
              id="SVGID_00000085940940171884276270000010021778272666549167_"
              cx="-4271.672"
              cy="1613.322"
              r="70.687"
              gradientTransform="matrix(.2792 .9777 -.9863 .247 2960.696 3975.42)"
              gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FFF" stopOpacity="0.7"></stop>
            <stop offset="1" stopColor="#FFF"></stop>
          </radialGradient>
          <path
              fill="url(#SVGID_00000085940940171884276270000010021778272666549167_)"
              d="M220.8 257.3 130 204.9c-9.1-5.2-12.2-16.8-6.9-25.9l10.5-18.1c5.2-9.1 16.8-12.2 25.9-6.9l90.8 52.4c9.1 5.2 12.2 16.8 6.9 25.9l-10.5 18.1c-5.2 9-16.8 12.2-25.9 6.9"
          ></path>
        </svg>
    )
;


export default AnprLogo

